import { createContext, useState } from 'react';

import { API_BASE_URL } from '../../config/baseURLs';
import axiosInstance from '../../api/axiosInstance';

const FranchiseQueueContext = createContext();

export const FranchiseQueueProvider = ({ children }) => {
	const [data, setData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState(null);
	const [view, setView] = useState('open-queue');
	const [franchiseandPM, setFranchiseandPM] = useState(null);

	const getData = () => {
		setIsLoading(true);
		axiosInstance
			.get(`${API_BASE_URL}/franchise-queue?view=${view}`)
			.then((response) => {
				const responseData = response.data?.data || [];
				setData(responseData);
				setError(null);
			})
			.catch((err) => {
				setError(err);
				setData(null);
			})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const getFranchiseandPM = () => {
		axiosInstance
			.get(`${API_BASE_URL}/franchiseandpm`)
			.then((response) => {
				const responseData = response.data?.data || [];
				setFranchiseandPM(responseData);
			})
			.catch((err) => {
				setFranchiseandPM(null);
			});
	};

	return (
		<FranchiseQueueContext.Provider
			value={{
				getData,
				data,
				setData,
				isLoading,
				error,
				view,
				setView,
				getFranchiseandPM,
				franchiseandPM,
			}}
		>
			{children}
		</FranchiseQueueContext.Provider>
	);
};

export default FranchiseQueueContext;
